// Flowbite component
import { Tooltip } from 'flowbite-react';

export const getTitleTooltip = (
  title: string | undefined,
  truncatedTitle: string
) => {
  if (title && title.length > 30) {
    return (
      <Tooltip content={title} placement="top" className="text-center">
        {truncatedTitle}
      </Tooltip>
    );
  }
  return truncatedTitle;
};
